import React from 'react';
import styles from './index.less';

const EmptyPage = ({ text = '暂无记录', img = 'nothing.png', wrapStyle = {} }) => {
  const reg = /^https?/gi;
  return (
    <div className={styles.emptyWrap} style={{ ...wrapStyle }}>
      <div className={styles.emptyImg}>
        <img src={reg.test(img) ? img : require(`@/assets/images/${img}`)} alt="nothing" />
        <p className={styles.emptyText}>{text}</p>
      </div>
    </div>
  );
};

export default EmptyPage;
